import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { IZoomEvent } from '../../../_models/models';
import { ComponentContainer } from 'golden-layout';
import { GoldenLayoutContainerInjectionToken, WidgetHostDirective } from '../../../_directives/widget-host.directive';
import { Alarme, IAlarme } from '../../../_models/Alarme';
import { MainStoreState } from '../../../_store/mainStoreState';
import { Store } from '@ngrx/store';
import { loadAlarmesAction, selectAllAlarmes } from '../../../_store/AlarmeStore/alarme.store';
import { GridWrapper } from '../../../_models/GridWrapper';
import { ConfigService } from '../../../_services/local/config.service';
import { ConfirmService } from '../../../_services/local/confirm.service';
import { AlarmeService } from '../../../_services/http/alarme.service';
import { getCurrentUserRole } from '../../../_store/AccountStore/account.store';
import { GridComponent } from '@progress/kendo-angular-grid';
import { DashboardService } from '../../dashboard/dashboard.service';
import { distinct } from '@progress/kendo-data-query';

@Component({
  selector: 'app-alarme-list',
  templateUrl: './alarme-list.component.html',
  styleUrls: ['./alarme-list.component.scss'],
})
export class AlarmeListComponent extends WidgetHostDirective implements OnInit, OnDestroy {
  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  // Grid attributes
  gridWrapper = new GridWrapper<Alarme>(
    'Alarme',
    this.store.select(selectAllAlarmes),
    {
      logic: 'or',
      filters: [
        {
          field: 'localisation',
          operator: 'contains',
        },
        {
          field: 'description',
          operator: 'contains',
        },
        {
          field: 'descriptionCriticite',
          operator: 'contains',
        },
        {
          field: 'descriptionEtat',
          operator: 'contains',
        },
        {
          field: 'dateDeclenchement',
          operator: 'contains',
        },
      ],
    },
    this.kendoGrid
  );
  alarmeCriticites = this.configService.Config.alarmeCriticites;
  userRole$ = this.store.select(getCurrentUserRole);

  channel = new BroadcastChannel('map-vec');

  constructor(
    private configService: ConfigService,
    private dashboardService: DashboardService,
    private confirmService: ConfirmService,
    private crudService: AlarmeService,
    @Inject(GoldenLayoutContainerInjectionToken) container: ComponentContainer,
    elRef: ElementRef,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    store: Store<MainStoreState>
  ) {
    super(container, elRef.nativeElement, renderer, viewContainerRef, store);
    this.gridWrapper.gridState.sort = [
      {
        field: 'dateDeclenchement',
        dir: 'desc',
      },
    ];
  }

  ngOnInit(): void {
    this.store.dispatch(loadAlarmesAction());

    this.channel.addEventListener('message', (evt) => {
      if (evt.data.type === 'select') {
        const alarme: Alarme = evt.data.data;
        if (alarme && alarme.id) {
          this.gridWrapper.mySelection = [alarme.id];
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.gridWrapper.destroy();
  }

  getAlarmeColor(idCriticite: number): string {
    const criticite = this.alarmeCriticites.find((s) => s.code === idCriticite);
    return criticite ? criticite.color : 'white';
  }

  demanderQuittancement(dataItem: Alarme): void {
    this.confirmService
      .open(`Voulez-vous demander le quittancement pour l'alarme`, dataItem.description, this.crudService.demanderQuittance(dataItem))
      .then((res) => {});
  }

  demanderAcquittement(dataItem: Alarme): void {
    this.confirmService
      .open(`Voulez-vous demander l'acquittement pour l'alarme`, dataItem.description, this.crudService.demanderAcquittement(dataItem))
      .then((res) => {});
  }

  zoomTo(event: MouseEvent, alarme: IAlarme): void {
    event.stopPropagation();

    if (!this.configService.Config.layers) {
      return;
    }

    const data: IZoomEvent<IAlarme> = {
      type: 'zoom',
      title: this.configService.Config.layers.alarme.title,
      searchField: this.configService.Config.layers.alarme.searchField,
      searchText: alarme.id.toString(),
      layerUrl: this.configService.Config.layers.alarme.url,
      subLayerIds: this.configService.Config.layers.alarme.layerIds,
    };

    if (this.dashboardService.isWidgetOpen('MapVecComponent')) {
      this.channel.postMessage(data);
      this.dashboardService.focusWidget('MapVecComponent');
    } else {
      this.dashboardService.openWidget('MapVecComponent', data);
    }
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.internalData, fieldName).map(
      // @ts-ignore
      (item) => item[fieldName]
    );
  }
}
